var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var AuthedUserSession = require('./AuthedUserSession');

module.exports = function(){
	radio('invalidate_Sitelists_cache').broadcast();
	radio('Sitelists_get').broadcast({id: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]), clear_cache: true});
};



// WEBPACK FOOTER //
// ./src/utils/reloadSitelists.js